import React, {useEffect} from 'react'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Form from 'react-bootstrap/Form'
import moment from 'moment-timezone'
import {useAuth} from 'util/auth'
import {useSelector} from 'react-redux'
import {symbolFromCurrency} from 'components/PartnerInfoForm'
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 

const buildPricingTextFromOffering = ({isOneTimeOffer, frequency, discountType, expiresIn, firstPeriodPrice, price, freeTrialPeriodDays, ...otherProps}) => {

    if (otherProps.pricingOptions && otherProps.pricingOptions.length > 0) {
        return "Choose pricing option below"
    }

    if (otherProps.promoCodePurchaseOnly) {
        return "Promo code access only"
    }

    if (!isOneTimeOffer) {
        return String(price) + `${frequency === 'once' ? "" : "/" + frequency}`
    }

    if (!expiresIn) {
        return
    }
    
    if (discountType === 'firstPeriodDiscount') {
        return `First ${frequency.replace("ly", "")} ${firstPeriodPrice}, then ${price}/${frequency}`

    } else if (discountType === 'freeTrial') {
        return `First ${freeTrialPeriodDays ?? 0} days free, then ${price}/${frequency}`
    }

    return null
}

function OfferingCell({selected, onClick, model}) {

    let view = (<></>)

    if (model.offering) {
        const title = "⭐️ " + model.offering.name
        let subtitle = null
        switch (model.offering.type) {
        case "subscription":
            if (model.canceled) {
                subtitle = `Expires ${moment(model.expires * 1000).format("LL")}`
            } else {
                subtitle = `Renews ${moment(model.expires * 1000).format("LL")}`
            }

            if (model?.offering?.subscriptionType === 'limited') {
                subtitle = `${model.remaining} remaining • ` + subtitle
            }
            
            // "$" + String(model.price) + `/${model.frequency}`
            break
        case "pack":
            subtitle = `${model.remaining} remaining`
            // subtitle = `${model.count} sessions for $${model.price}`
            break
        }
        
        view = (
            <div>
                <h6>{title}</h6>
                {subtitle && (
                    <p className="mb-0">{subtitle}</p>
                )}
            </div>
        )

    } else if (model.type === 'subscription' || model.type === "pack" || model.type === "challenge") {
        // must be an offering
        const title = model.name
        var subtitle = null
        switch (model.type) {
        case "challenge":
            subtitle = buildPricingTextFromOffering(model)
        case "subscription":
            subtitle = buildPricingTextFromOffering(model)
            if (model?.subscriptionType === 'limited') {
                subtitle = `${model.count} sessions • ` + subtitle
            }
            break
        case "pack":
            subtitle = `${model.count} ${model.count > 1 ? "sessions" : "session"} • ${model.price}`
            if (model.expires) {
                subtitle = subtitle +  ` • expires after ${model.expiresIn} days`
            }
            break
        }
        
        view = (
            <div>
                <h6>{title}</h6>
                {subtitle && (
                    <p className="mb-0">{subtitle}</p>
                )}
            </div>
        )

    } else if (model.purchase_type) {
        // must be a class
        const title = `Single Class`
        var subtitle = null
        switch (model.purchase_type) {
        case "free":
        case "Free":
            subtitle = "Free"
            break
        case "donation":
        case "Donation":
            if (model.minimum_price) {
                subtitle = `Sliding scale - ${model.price} (${model.minimum_price} minimum)`
            } else {
                subtitle = `Sliding scale - ${model.price} suggested`
            }
            break
        case "paid":
        case "Paid":
            subtitle = `${model.price}`
            if (model.viewModel) {
                switch (model.viewModel.type) {
                case "rental":
                    subtitle = `${model.price} • ${model?.rentalPeriodHours}-hour rental`
                    break
                case "dropin":
                    subtitle = `${model.price}`
                    break
                }
            }
            break
        }
        // console.log(subtitle)
        view = (
            <div>
                <h6>{title}</h6>
                {subtitle && (
                    <p className="mb-0">{subtitle}</p>
                )}
            </div>
        )
    }

    return (
        // onClick={() => setSelectedIndex(index)}
        // <div onClick={onClick} key={index} className={`card w-100 my-3 p-2 ${selectedIndex === index ? "border border-primary" : ""}`}></div>
        <div onClick={onClick} className={`card w-100 my-3 p-2 ${selected ? "border border-primaryColor" : ""}`}>
            <div className="d-flex d-row justify-content-between align-items-center">
                {view}
                {selected ? (
                    <RadioButtonCheckedIcon className="primaryColor" />
                ) : (
                    <RadioButtonUncheckedIcon className="primaryColor" />
                )}
            </div>
            
        </div>

    )
}



function OfferingSelector(props) {

    const currency = useSelector(state => state.widget.instructor.instructorProfile?.currency ?? "USD");
    const instructorEmail = useSelector(state => state.widget.instructor?.email);
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });
    const auth = useAuth()
    // product data could be offering or class
    const productData = props.class ?? props.offering; // class that we're talking about.. 
    const isSubscriptionOnly = (productData?.isSubscriptionOnly || productData?.frequency === 'subscription' || (productData?.allowsRental === false && productData?.allowsDropin === false)) ?? false
    var {
        // isPurchasable, // whether or not they should be able to purchase it for free
        purchases, // 
        offerings // offerings from that instructor
    } = props;

    var allowsDonateLater = true
    if (productData?.minimum_price && productData?.minimum_price > 0) {
        allowsDonateLater = false
    }
    
    // console.log("Got some offerings?")
    // console.log(offerings)

    const [selectedIndex, setSelectedIndex] = React.useState(null)

    var models = []
    
    if (productData.location_type === 'ondemand') {
        if (productData.allowsDropin) {
            models = models.concat({
                ...productData,
                viewModel: {
                    type: 'dropin',
                    price: productData.price
                }
            })
        }
        if (productData.allowsRental) {
            models = models.concat({
                ...productData,
                viewModel: {
                    type: 'rental',
                    price: productData.rentalPrice
                }
            })
        }
    } else {
        models = isSubscriptionOnly ? [] : (productData ? [productData] : [])
    }
    models = models.concat(purchases.filter(val => {
        if (isSubscriptionOnly) {
            return val?.offering?.type === 'subscription'
        }
        return true
    }))

    offerings.sort((a,b) => {

        if (productData?.type == 'challenge' && ['5x0TQEZh7Hdk7lgcgYrzhU52zI93'].includes(productData.partnerId) && a.type === b.type) {
            return (a.price < b.price) ? 1 : (a.price > b.price) ? -1 : 0;
        } else if (a.type === b.type) {
            return (a.price < b.price) ? -1 : (a.price > b.price) ? 1 : 0;
        } else {
            return (a.type < b.type) ? -1 : 1
        }
    }).forEach(offer => {
        var shouldAdd = true
        if (isSubscriptionOnly && offer.type !== 'subscription') {
            shouldAdd = false
        }
        purchases.forEach(purchase => {
            // if user already has this offering, don't add it
            if (purchase.offering?.id === offer.id) {
                shouldAdd = false
            }
        })
        if (shouldAdd) {
            models.push(offer)
        }
    })

    models.forEach(val => {
        if (val.type === "subscription") {
            val.isSubscription = true
        }
    })
    // offerings = [{
    //     name: `Single Drop In - ${classData.purchase_type}`,
    //     price: classData.price,
    // }].concat(offerings.map(val => {
    //     var priceString = "$" + String(val.price)
    //     if (val.type === 'subscription') {
    //         priceString = priceString + `/${val.frequency}`
    //     }
    //     return {
    //         ...val,
    //         name: `${val.name} - ${priceString}`
    //     }
    // }))

    
    const isDonation = productData?.purchase_type?.toLowerCase() === "donation" && selectedIndex === 0
    const [payment, setPayment] = React.useState(productData.price);
    // const isFree = classData.purchase_type?.toLowerCase() === 'free' && selectedIndex === 0
    // const [takeOnFee, setTakeOnFee] = React.useState(true)
    // const extraCents = payment > 0 ? 0.3 : 0
    // const serviceFee = calculateServiceFee(payment)
    const [modelSelected, setModelSelected] = React.useState(null) 

    const reactElement = () => {
        var element = null
        // selectedOffering.descriptionHTML ? htmlToReactParser.parse(selectedOffering.descriptionHTML) : null;
        if (modelSelected?.offering?.descriptionHTML) {
            element = htmlToReactParser.parse(modelSelected.offering.descriptionHTML)
        } else if (modelSelected?.type === 'subscription' || modelSelected?.type === "pack") {
            if (modelSelected?.descriptionHTML) {
                element = htmlToReactParser.parse(modelSelected.descriptionHTML)
            }
        } 
        // else if (model.purchase_type) {
            
        // }
        return (
            <div className="mb-3">
                <span className="primary-text">{element}</span>
                
            </div>
        )
    } 
    
    // function handleSetPayment(e) {
    //     const val = Number(e.target.value)
    //     setPayment(val)
    //     selectIndex(selectedIndex)
    // }

    function selectIndex(index) {
        setSelectedIndex(index)
        const selectedModel = models[index]
        setModelSelected(selectedModel)
        if (selectedModel?.purchase_type) { // model is a class
            const checkoutModel = {
                dropIn: true,
                // payment: Number(payment),
                takeOnFee: true,
                // type: "dropin",
                type: selectedModel?.viewModel?.type ?? "dropin",
                payment: Number(selectedModel?.viewModel?.price ?? payment),
                class: {
                    ...selectedModel,
                    id: selectedModel.platformID
                }
            }
            console.log("Selected drop in: ", checkoutModel)
            if (props.onChange) {
                props.onChange(checkoutModel)
            }
            
        } else if (selectedModel?.type === 'subscription' || selectedModel?.type === "pack") {
            // selected a new offering
            const checkoutModel = {
                dropIn: false,
                offeringId: selectedModel.id,
                type: selectedModel.type,
                payment: Number(selectedModel.price),
                offering: {
                    ...selectedModel
                }
            }
            console.log("Selected offering: ", checkoutModel)
            if (props.onChange) {
                props.onChange(checkoutModel)
            }
            
        } else if (selectedModel?.type === "challenge") {
            const checkoutModel = {
                dropIn: false,
                offeringId: selectedModel.id,
                type: selectedModel.type,
                payment: Number(selectedModel.price),
                promoCode: selectedModel.promoCode,
                promoCodePurchaseOnly: selectedModel.promoCodePurchaseOnly ? true : false,
                dollarDiscount: Number(selectedModel.dollarDiscount),
                offering: {
                    ...selectedModel
                }
            }

            if (checkoutModel.promoCodePurchaseOnly) {
                checkoutModel.payment = 0
            }

            console.log("Selected challenge: ", checkoutModel)
            if (props.onChange) {
                props.onChange(checkoutModel)
            }

        } else if (selectedModel?.offering) {
            // selected a previous purchase
            const checkoutModel = {
                dropIn: false,
                purchaseId: selectedModel.id,
                type: "purchase",
                payment: 0
            }
            
            console.log("Selected purchase: ", checkoutModel)
            if (props.onChange) {
                props.onChange(checkoutModel)
            }
        } 
    }

    useEffect(() => {
        if (selectedIndex === null) {
            var indexToSelect = 0
            models.forEach((val, index) => {
                if (indexToSelect === 0 && val.remaining > 0) {
                    indexToSelect = index
                }
            })
            // console.log("Models 1: ", models)
            selectIndex(indexToSelect)
        }
    }, [selectedIndex])

    useEffect(() => {
        // if (selectedIndex !== 0) {
        // }
        var indexToSelect = 0
        models.forEach((val, index) => {
            if (indexToSelect === 0 && val.remaining > 0) {
                indexToSelect = index
            }
        })
        // console.log("user changed: ", models)
        selectIndex(indexToSelect)
    }, [auth?.user])

    useEffect(() => {
        
        if (selectedIndex !== null) {
            selectIndex(0)
        }
        
    }, [payment])

    

    // if model is class
    //   get the price and use dropin == true
    // if model is offering
    //   get the offeringId, use dropin == false
    // if model is purchase
    //    get the purchaseId, use dropIn == false    

    return (
        <div>
            {models.map((val, index) => {
                var price = val?.viewModel?.price || val?.viewModel?.price === 0 ? val.viewModel.price : val.price
                return (
                <OfferingCell
                    key={index} 
                    selected={selectedIndex === index} 
                    onClick={() => selectIndex(index)}
                    model={{
                        ...val,
                        price: currencyFormatter.format(price),
                        firstPeriodPrice: currencyFormatter.format(val?.firstPeriodPrice ?? 0)
                    }}
                />)
            })}
            {isDonation && (
            <>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">{symbolFromCurrency(currency)}</span>
                    </div>
                    {/* defaultValue={payment} */}
                    <input value={payment} onChange={(e) => setPayment(e.target.value)} placeholder={"Enter Amount"} type="number" className="form-control" aria-label="Amount (to the nearest dollar)"/>
                    <div className="input-group-append">
                        <span className="input-group-text">.00</span>
                    </div>
                </div>
                {allowsDonateLater && (
                <Form.Group>
                    <Form.Check 
                        // checked={marketingEmails}
                        type="switch"
                        id="donation-switch"
                        onChange={(e) => setPayment(e.target.checked ? 0 : productData.price)}
                        label={`I prefer to donate later`}
                    />
                </Form.Group>
                )}
            </>
            )}
            {reactElement()}
            {modelSelected?.isSubscription && (
                <p className="text-center" style={{fontSize: 'smaller'}}>
                    By starting the service, you authorize us to charge your credit or debit card, agree to our <a className="primaryColor" target="_blank" href="https://www.sutra.fit/terms">Terms of Service</a> &amp; <a className="primaryColor" target="_blank" href="https://www.sutra.fit/privacy">Privacy Policy</a>, and represent that you are at least 16 years of age. <strong className="font-weight-bold">Your subscription will automatically renew until canceled.</strong> To cancel at anytime please visit your purchases in your profile or contact your instructor at <a className="primaryColor" target="_blank" href={"mailto:" + instructorEmail}>{instructorEmail}</a>.
                </p>
            )}
        </div>

    )
}

export default OfferingSelector